<!--
 * @Author: wangxb 18254141586@163.com
 * @Date: 2023-11-29 15:26:10
 * @LastEditors: wangxb 18254141586@163.com
 * @LastEditTime: 2023-12-04 16:04:01
 * @FilePath: \ui-jfgjgl-v2\src\views\dataBoard\components\collection\index.vue
 * @Description:
-->
<template>
  <div class="board-container">
    <div class="board-panel">
      <div class="board-panel__header">
        回款汇总数据
      </div>
      <div class="board-panel__body">
        <div class="board-flex">
          <div class="board-flex__item row-1-col-1-5 small">
            <div class="data-item">
              <div class="data-item__value c-c18d1f">{{statisticsInfo.collectionNum}}</div>
              <div class="data-item__title">回款笔数</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-1-5 small">
            <div class="data-item">
              <div class="data-item__value c-427fdc">￥{{statisticsInfo.collectionAmount | formatMoney}}</div>
              <div class="data-item__title">回款总金额（含税）</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-1-5 small">
            <div class="data-item">
              <div class="data-item__value c-427fdc">￥{{statisticsInfo.collectionAmountExcludingTaxes | formatMoney}}</div>
              <div class="data-item__title">回款总金额（不含税）</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-1-5 small">
            <div class="data-item">
              <div class="data-item__value c-c18d1f">{{statisticsInfo.projectNum}}</div>
              <div class="data-item__title">相关项目数量</div>
            </div>
          </div>
          <div class="board-flex__item row-1-col-1-5 small">
            <div class="data-item">
              <div class="data-item__value c-c18d1f">{{statisticsInfo.contractNum}}</div>
              <div class="data-item__title">相关合同数量</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="board-panel">
      <div class="board-panel__header">
        回款列表数据
      </div>
      <div class="board-panel__body table-content">
        <el-table :data="tableData"
                  ref="detailTable"
                  size="mini"
                  :summary-method="getSummaryMethod"
                  border
                  fit
                  show-summary
                  class="board-table"
                  height="95%"
                  stripe
                  header-row-class-name="board-table-header"
                  style="width: 100%">
          <el-table-column prop="collectionCode"
                           show-overflow-tooltip
                           label="回款登记编号"
                           align="center"
                           width="130">
          </el-table-column>
          <el-table-column prop="collectionAmount"
                           label="回款金额（含税）"
                           header-align="center"
                           align="right"
                           width="130">
            <template slot-scope="scope">
              ￥{{scope.row.collectionAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="collectionAmountExcludingTaxes"
                           label="回款金额（不含税）"
                           header-align="center"
                           align="right"
                           width="130">
            <template slot-scope="scope">
              ￥{{scope.row.collectionAmountExcludingTaxes | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="collectionTime"
                           show-overflow-tooltip
                           label="回款时间"
                           align="center"
                           width="90">
          </el-table-column>
          <el-table-column prop="contractCode"
                           show-overflow-tooltip
                           label="所属合同编号"
                           align="center"
                           width="110">
          </el-table-column>
          <el-table-column prop="contractName"
                           show-overflow-tooltip
                           align="center"
                           min-width="200"
                           label="所属合同名称">
          </el-table-column>
          <el-table-column prop="contractSignDate"
                           show-overflow-tooltip
                           align="center"
                           width="120"
                           label="所属合同签约日期">
          </el-table-column>
          <el-table-column prop="partyA"
                           show-overflow-tooltip
                           align="center"
                           min-width="200"
                           label="甲方名称">
          </el-table-column>
          <el-table-column prop="implementationDeptName"
                           show-overflow-tooltip
                           align="center"
                           width="120"
                           label="实施部门">
          </el-table-column>
          <el-table-column prop="contractAmount"
                           header-align="center"
                           align="right"
                           width="130"
                           label="合同金额（含税）">
            <template slot-scope="scope">
              ￥{{scope.row.contractAmount | formatMoney}}
            </template>
          </el-table-column>
          <el-table-column prop="projectLeader"
                           show-overflow-tooltip
                           align="center"
                           width="90"
                           label="项目负责人">
          </el-table-column>
          <el-table-column prop="contractType"
                           show-overflow-tooltip
                           align="center"
                           width="90"
                           label="合同类型">
          </el-table-column>
          <el-table-column prop="contractCustomTypeName"
                           show-overflow-tooltip
                           align="center"
                           width="110"
                           label="合同自定义类型">
          </el-table-column>
          <el-table-column prop="projectCode"
                           show-overflow-tooltip
                           align="center"
                           width="140"
                           label="所属项目编号">
          </el-table-column>
          <el-table-column prop="projectName"
                           show-overflow-tooltip
                           align="center"
                           width="140"
                           label="所属项目名称">
          </el-table-column>
        </el-table>
        <div class="table-page">
          <el-pagination background
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"
                         layout="total, sizes, prev, pager, next"
                         :current-page.sync="currentPage"
                         :page-sizes="[10,20,30,40,50,60,70,80,90,100]"
                         :page-size="pageParams.size"
                         popper-class="custom-page-sizes-popper-class"
                         :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCollectionStatisticsData, getCollectionStatisticsDetail } from '@/api/dataBoard'
import { toThousands } from '@/utils/tools'
export default {
  data() {
    return {
      searchParams: {},
      statisticsInfo: {},
      pageParams: {
        current: 1,
        size: 30
      },
      total: 0,
      currentPage: 1,
      tableData: [],
      allTotal: {},
      currentPageTotal: {}
    }
  },
  methods: {
    /**
     * @Description: 加载数据内容
     * @param {*} searchParams
     * @return {*}
     */
    initPage(searchParams) {
      this.searchParams = searchParams
      this.pageParams.current = 1
      this.currentPage = 1
      this.loadStatisticsData()
      this.loadStatisticsDataDetail()
    },
    /**
     * @Description: 获取汇总数据
     * @return {*}
     */
    loadStatisticsData() {
      getCollectionStatisticsData(this.searchParams).then(res => {
        if (res.success) {
          this.statisticsInfo = res.obj
        } else {
          this.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    },
    /**
     * @Description: 获取回款列表数据
     * @return {*}
     */
    loadStatisticsDataDetail() {
      getCollectionStatisticsDetail(this.pageParams, this.searchParams).then(res => {
        if (res.success) {
          this.tableData = res.obj.detailList.records
          this.allTotal = res.obj.allTotal
          this.currentPageTotal = res.obj.currentPageTotal
          this.total = res.obj.detailList.total
          this.$nextTick(() => {
            this.$refs.detailTable.doLayout()
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: res.message
          })
        }
      })
    },
    /**
     * @Description: table底部合计
     * @param {*} columns
     * @return {*}
     */
    getSummaryMethod({ columns }) {
      const { allTotal, currentPageTotal } = this
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = <div class="countClass"><div class="count_row">小计</div><div class="count_row">合计</div></div>
          return
        }

        sums[index] = <div class="countClass"><div class="count_row"></div><div class="count_row"></div></div>
        if (column.property === 'collectionAmount' || column.property === 'collectionAmountExcludingTaxes') {
          const subSum = `￥${toThousands(currentPageTotal[column.property])}`
          const totalSum = `￥${toThousands(allTotal[column.property])}`
          sums[index] = <div class="countClass"><div class="count_row">{subSum}</div><div class="count_row">{totalSum}</div></div>
        }
      })
      return sums
    },
    /**
     * @Description: 分页 没有条数改变
     * @param {*} val
     */
    handleSizeChange(val) {
      this.$refs.detailTable.bodyWrapper.scrollTop = 0
      this.pageParams.size = val
      this.pageParams.current = 1
      this.currentPage = 1
      this.loadStatisticsDataDetail()
    },
    /**
     * @Description: 分页 页码改变
     * @param {*} val
     */
    handleCurrentChange(val) {
      this.$refs.detailTable.bodyWrapper.scrollTop = 0
      this.pageParams.current = val
      this.loadStatisticsDataDetail()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/style/dataBoard.scss";
</style>
